"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLayoutAnimation = void 0;
const react_1 = require("react");
const throttle_1 = __importDefault(require("lodash/throttle"));
function useLayoutAnimation() {
    const direction = (0, react_1.useRef)(1);
    const [isAnimating, setIsAnimating] = (0, react_1.useState)(false);
    // Throttle the animation status updates to avoid rapid state changes
    const setAnimationStatus = (0, throttle_1.default)((status) => {
        setIsAnimating(status);
    }, 350);
    // Scroll to top when animation completes
    (0, react_1.useLayoutEffect)(() => {
        if (!isAnimating) {
            window.scrollTo(0, 0);
        }
    }, [isAnimating]);
    // Animation completion handler
    const onAnimationComplete = (0, react_1.useCallback)(() => {
        setAnimationStatus(false);
        // Reset direction to forward after backward animation completes
        if (direction.current === -1) {
            direction.current = 1;
        }
    }, [setAnimationStatus]);
    // Animation start handler
    const onAnimationStart = (0, react_1.useCallback)(() => {
        setAnimationStatus(true);
    }, [setAnimationStatus]);
    // Function to set animation direction to backward
    const setBackDirection = (0, react_1.useCallback)(() => {
        direction.current = -1;
    }, []);
    return {
        direction,
        isAnimating,
        onAnimationComplete,
        onAnimationStart,
        setBackDirection
    };
}
exports.useLayoutAnimation = useLayoutAnimation;
//# sourceMappingURL=useLayoutAnimation.js.map